/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedNumber } from 'react-intl';
import debounce from 'lodash.debounce';
import downloadjs from 'downloadjs';

import { luftGet, luftDownload } from '../../shared/http';
import Table from '../../components/Table';
import SubHeader from '../../components/SubHeader';
import Pagination from '../../components/Pagination';
import { getManifestsInTransit } from '../../redux/manifests-in-transit';
import FiltersContainer from '../../components/Filter/FiltersContainer';
import CurrentFilters from '../../components/CurrentFilters';

import './styles.css';
import ProgressBar from '../../components/ProgressBar';
import Details from './Details';
import Totalizers from '../../components/Totalizers';
import Search from '../../components/Search';
import Button from '../../components/Button';

import {
  SubHeaderFunctionContainer,
  SubHeaderFunctionsBar,
  StatusContainer,
  PerformanceContainer,
} from './styles';
import { loggedUserRequestErrorHandler } from '../../shared/http/error';
import LoadingIndicator from '../../components/LoadingIndicator';
import Icon from '../../components/Icon';
import {
  PERFORMANCE_ENUM,
  PERFORMANCE_ENUM_TRANSKEY,
  PERFORMANCE_COLORS,
} from '../../enums/performance-enum';

const PAGINATION_OPTIONS = [
  {
    value: 10,
    label: '10',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
];

const STATUS_ENUM = {
  IN_TRANSIT: 1,
  FINISHED: 2,
  NOT_STARTED: 3,
};

const STATUS_STYLE_ENUM = {
  [STATUS_ENUM.IN_TRANSIT]: {
    color: '#2580ac',
    icon: 'truck',
  },
  [STATUS_ENUM.FINISHED]: {
    color: '#4CAF50',
    icon: 'check_circle_checked',
  },
  [STATUS_ENUM.NOT_STARTED]: {
    color: '#F44336',
    icon: 'schedule',
  },
};

const STATUS_ENUM_TRANSKEY = {
  [STATUS_ENUM.IN_TRANSIT]: 'Em trânsito',
  [STATUS_ENUM.FINISHED]: 'Finalizado',
  [STATUS_ENUM.NOT_STARTED]: 'Não Iniciado',
};

const DEFAULT_AMOUNT = 50;
const SEARCH_BY_TERM_TIMEOUT = 1000;

const FILTERS = {
  destination: 'destination',
  status: 'status',
  performance: 'performance',
  plates: 'plates',
  branches: 'branches',
  clients: 'clients',
};

const FILTER_PARAMS_ENUM = {
  destination: 'listDestCity',
  status: 'listStatus',
  performance: 'listPerformance',
  plates: 'listPlates',
  branches: 'listBranches',
  clients: 'listClients',
};

const FILTER_OPTIONS_ENDPOINT = {
  [FILTERS.destination]: 'GetDestinationFilter',
  [FILTERS.status]: 'GetStatusFilter',
  [FILTERS.performance]: 'GetPerformanceFilter',
  [FILTERS.plates]: 'GetPlateFilter',
  [FILTERS.branches]: 'GetBranchFilter',
  [FILTERS.clients]: 'GetClientsFilter',
};

class ManifestsInTransit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentRecordsPerPage: 30,
      currentPage: 1,
      currentShippingCompanyIdFilter: null,
      currentManifestId: null,
      totalizers: 0,
      currentPlateFilter: '',
      currentManifestFilter: '',
      currentTmsFilter: '',
      currentNfFilter: '',
      currentDestinationFilter: '',
      progressBarState: 100,
      progressTime: 300000,
      isFetchingFilters: false,
      destination: {
        data: [],
        total: 0,
        page: 1,
      },
      manifest: {
        data: [],
        total: 0,
        page: 1,
      },
      plates: {
        data: [],
        total: 0,
        page: 1,
      },
      branches: {
        data: [],
        total: 0,
        page: 1,
      },
      clients: {
        data: [],
        total: 0,
        page: 1,
      },
      status: {
        data: [
          {
            id: STATUS_ENUM.IN_TRANSIT,
            name: STATUS_ENUM_TRANSKEY[STATUS_ENUM.IN_TRANSIT],
          },
          {
            id: STATUS_ENUM.FINISHED,
            name: STATUS_ENUM_TRANSKEY[STATUS_ENUM.FINISHED],
          },
          {
            id: STATUS_ENUM.NOT_STARTED,
            name: STATUS_ENUM_TRANSKEY[STATUS_ENUM.NOT_STARTED],
          },
        ],
      },
      performance: {
        data: [
          {
            id: PERFORMANCE_ENUM.ON_TIME,
            name: PERFORMANCE_ENUM_TRANSKEY[PERFORMANCE_ENUM.ON_TIME],
          },
          {
            id: PERFORMANCE_ENUM.RISK_OF_DELAY,
            name: PERFORMANCE_ENUM_TRANSKEY[PERFORMANCE_ENUM.RISK_OF_DELAY],
          },
          {
            id: PERFORMANCE_ENUM.DELAYED,
            name: PERFORMANCE_ENUM_TRANSKEY[PERFORMANCE_ENUM.DELAYED],
          },
        ],
      },
      filters: {
        destination: this._setStateFilters('Destino', 'destination'),
        manifest: this._setStateFilters('Manifesto', 'manifest'),
        performance: this._setStateFilters('Performance', 'performance'),
        plates: this._setStateFilters('Plate', 'plates'),
        branches: this._setStateFilters('Branch', 'branches'),
        clients: this._setStateFilters('Clients', 'clients'),
        status: this._setStateFilters('Status', 'status', {
          id: STATUS_ENUM.IN_TRANSIT,
          name: STATUS_ENUM_TRANSKEY[STATUS_ENUM.IN_TRANSIT],
        }),
      },
    };
    this._searchByTerm = debounce((type, term) => {
      this.setState(
        prevState => ({
          [type]: {
            ...prevState[type],
            page: 0,
            data: prevState[type].data.filter(item => item.name.includes(term)),
          },
          filters: {
            ...prevState.filters,
            [type]: {
              ...prevState.filters[type],
              searchTerm: term,
            },
          },
        }),
        () => {
          this._getFilterByType(type, DEFAULT_AMOUNT);
        },
      );
    }, SEARCH_BY_TERM_TIMEOUT);
  }

  componentDidMount() {
    this._doFetch();
    this.fetchInterval = setInterval(this._doFetch, 300000);
    this.interval = this.controlProgressBar();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.fetchInterval);
  }

  _getInitialFilterOptions = async filterType => {
    const { dispatch } = this.props;

    try {
      this.setState({
        isFetchingFilters: true,
      });
      const response = await luftGet(
        `/OnTime/${FILTER_OPTIONS_ENDPOINT[filterType]}`,
        {
          page: 1,
          amount: DEFAULT_AMOUNT,
        },
      );

      const data =
        response.data[filterType === 'destination' ? 'destiny' : filterType];
      this.setState(prevState => ({
        [filterType]: {
          data: data || [],
          total: response.data.totalLines,
          page: 1,
        },
        page: 1,
        filters: {
          ...prevState.filters,
          [filterType]: {
            ...prevState.filters[filterType],
            hasNextPage: response.data.totalLines >= DEFAULT_AMOUNT,
          },
        },
        isFetchingFilters: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);
      this.setState({
        isFetchingFilters: false,
      });
    }
  };

  _setMultiSelectParamsToRequest = (id, transkey) => {
    Object.values(id).map(code => ({
      id: code,
      name: transkey[code],
    }));
  };

  _setStateFilters = (name, filterType, defaultValue) => ({
    name,
    value: defaultValue ? [defaultValue] : [],
    hasNextPage: true,
    searchTerm: null,
    clear: callBack => {
      this.setState(
        prevState => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            [filterType]: {
              ...prevState.filters[filterType],
              value: [],
            },
          },
        }),
        () => {
          if (callBack) {
            this._doFetch();
          }
        },
      );
    },
  });

  _exportExcel = async () => {
    const { dispatch } = this.props;

    try {
      const filterParams = this._checkFiltersOnRequest();

      this.setState({ isFetching: true });

      const params = {
        ...filterParams,
      };

      const mimeType = 'application/ms-excel';
      const response = await luftDownload(
        '/OnTime/ExportManifestsInExcelBase64',
        {
          ...params,
        },
        'application/json' || null,
      );

      const data = `data:${mimeType};base64,${JSON.parse(response).data}`;
      const filename = 'manifestos-em-transito.xlsx';

      downloadjs(data, filename, mimeType);

      this.setState({ isFetching: false });
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error, error.message);
    }
  };

  // Get Filter Options
  _getFilterByType = async (filterType, startIndex, stopIndex) => {
    const { dispatch } = this.props;
    try {
      this.setState({
        isFetchingFilters: true,
      });

      const response = await luftGet(
        `/OnTime/${FILTER_OPTIONS_ENDPOINT[filterType]}`,
        {
          page: this.state[filterType].page + 1,
          amount: DEFAULT_AMOUNT,
          searchTerm: this.state.filters[filterType].searchTerm
            ? this.state.filters[filterType].searchTerm
            : '',
        },
      );

      const data =
        response.data[filterType === 'destination' ? 'destiny' : filterType];

      this.setState(prevState => ({
        [filterType]: {
          data:
            (this.state[filterType].page
              ? data
                ? [...this.state[filterType].data, ...data]
                : this.state[filterType].data
              : data) || [],
          total: response.data.totalLines,
          page: this.state[filterType].page + 1,
        },
        filters: {
          ...prevState.filters,
          [filterType]: {
            ...prevState.filters[filterType],
            hasNextPage: response.data.totalLines >= startIndex,
          },
        },
        isFetchingFilters: false,
      }));
    } catch (error) {
      loggedUserRequestErrorHandler(dispatch, error);

      this.setState({
        isFetchingFilters: false,
      });
    }
  };

  controlProgressBar() {
    const interval = setInterval(() => {
      const { progressTime } = this.state;
      this.setState(prevState => ({
        progressBarState:
          progressTime === 0 ? 100 : prevState.progressBarState - 0.33,
        progressTime:
          progressTime === 0 ? 300000 : prevState.progressTime - 1000,
      }));
    }, 1000);
    return interval;
  }

  _checkFiltersOnRequest = () => {
    const { filters } = this.state;
    let params = {};
    // -disable-next-line no-restricted-syntax
    for (const key of Object.keys(filters)) {
      if (
        key === 'period' &&
        filters[key].value &&
        filters[key].value.initialPeriod &&
        filters[key].value.finalPeriod
      ) {
        params = {
          ...params,
          ...filters[key].value,
        };
      } else if (filters[key].value.length) {
        params[FILTER_PARAMS_ENUM[key]] = filters[key].value.map(val => val.id);
      }
    }
    return params;
  };

  _renderFormattedCounter = () => {
    let counterMinutes = moment
      .duration(this.state.progressTime)
      .minutes()
      .toString();
    let counterSeconds = moment
      .duration(this.state.progressTime)
      .seconds()
      .toString();

    if (counterMinutes.length === 1) {
      counterMinutes = `0${counterMinutes}`;
    }

    if (counterSeconds.length === 1) {
      counterSeconds = `0${counterSeconds}`;
    }

    return `${counterMinutes}:${counterSeconds}`;
  };

  _doFetch = searchTerm => {
    const { currentPage, currentRecordsPerPage } = this.state;

    const filterParams = this._checkFiltersOnRequest();
    const params = {
      page: currentPage,
      amount: currentRecordsPerPage,
      ManifestOrInvoice: searchTerm || '',
      ...filterParams,
    };

    this.props.getManifestsInTransit(params).then(data => {
      if (data) {
        if (data.pagination) {
          this.setState({
            currentPage:
              data.pagination.currentPage > 0 ? data.pagination.currentPage : 1,
            currentTotalItems: data.pagination.totalRecords,
            totalizers: data.pagination.totalRecords,
          });
        }
      }
    });
  };

  _handlePageChange = page => {
    this.setState({ currentPage: page }, () => {
      this._doFetch();
    });
  };

  _handlePageLimitChange = pageLimit => {
    this.setState({ currentRecordsPerPage: pageLimit }, () => {
      this._doFetch();
    });
  };

  _haveData() {
    if (this._getTableData().length > 0) {
      return true;
    }

    return false;
  }

  _onFilterByPlate = plates => {
    this.setState({ currentPlateFilter: plates, currentPage: 1 }, () => {
      this._doFetch();
    });
  };

  _onFilterByDestination = destination => {
    this.setState(
      { currentDestinationFilter: destination, currentPage: 1 },
      () => {
        this._doFetch();
      },
    );
  };

  _onFilterByManifest = manifest => {
    this.setState({ currentManifestFilter: manifest, currentPage: 1 }, () => {
      this._doFetch();
    });
  };

  _onFilterByTms = tms => {
    this.setState({ currentTmsFilter: tms, currentPage: 1 }, () => {
      this._doFetch();
    });
  };

  _onFilterByNf = nf => {
    this.setState({ currentNfFilter: nf, currentPage: 1 }, () => {
      this._doFetch();
    });
  };

  _onFilterByShippingCompanyId = selected => {
    this.setState(
      { currentShippingCompanyIdFilter: selected.value, currentPage: 1 },
      () => {
        this._doFetch();
      },
    );
  };

  _onSearch = (query, page) => {
    this.setState({ currentPage: page }, () => {
      this._doFetch(query);
    });
  };

  _renderRowStatus = status => (
    <StatusContainer color={STATUS_STYLE_ENUM[status].color}>
      <Icon name={STATUS_STYLE_ENUM[status].icon} />
      {STATUS_ENUM_TRANSKEY[status]}
    </StatusContainer>
  );

  _renderRowPerformance = performance => (
    <PerformanceContainer color={PERFORMANCE_COLORS[performance]}>
      <span>{PERFORMANCE_ENUM_TRANSKEY[performance]}</span>
    </PerformanceContainer>
  );

  _getTableData = () => {
    const { manifestsInTransit } = this.props;

    if (!manifestsInTransit) {
      return [];
    }

    return manifestsInTransit.map(line => ({
      manifest: line.manifest,
      date: moment(line.date).format('DD/MM/YYYY'),
      shippingGroupName: line.shippingGroupName,
      nomeMotorista: line.nomeMotorista,
      plates: line.plate,
      startDate: moment(line.startDate).format('DD/MM/YYYY'),
      endDate: line.endDate ? moment(line.endDate).format('DD/MM/YYYY') : '',
      code: line.code,
      value: (
        <p>
          R$
          <FormattedNumber
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            currencyDisplay="symbol"
            value={line.value}
            useGrouping
          />
        </p>
      ),
      totalDocuments: (
        <div className="ManifestsInTransit__progress-container">
          <ProgressBar
            completed={(line.finishedDocuments * 100) / line.totalDocuments}
          />
          <p className="ManifestsInTransit__progress-text">
            {line.finishedDocuments}/{line.totalDocuments}
          </p>
        </div>
      ),
      stops: line.stops,
      occurrences: line.occurrences,
      status: this._renderRowStatus(line.status),
      performance: this._renderRowPerformance(line.performance),
    }));
  };

  _getManifestNumberInRow = cells => cells[0].props.children;

  _onRowClick = cells => {
    const manifest = this._getManifestNumberInRow(cells);
    this.setState({ currentManifestId: manifest });
  };

  _handleSearchByTerm = async (term, type) => {
    // term ---> value
    // type ---> field name
    this._searchByTerm(type, term);
  };

  _getMultiSelectOptions = options =>
    Object.values(options).map((option, index) => ({
      id: index,
      name: option,
    }));

  _onDismiss = () => this.setState({ currentManifestId: null });

  _clearFilters = () => {
    const { filters } = this.state;
    const clearedFilter = {};
    // -disable-next-line no-restricted-syntax
    for (const key of Object.keys(filters)) {
      if (key === 'period') {
        clearedFilter[key] = {
          ...filters[key],
          value: {
            // finalPeriod: moment().format('YYYY-MM-DD'),
            // initialPeriod: moment().subtract(INITIAL_FILTER_PERIOD, 'day').format('YYYY-MM-DD'),
          },
        };
      } else {
        clearedFilter[key] = { ...filters[key], value: [] };
      }
    }
    this.setState(
      () => ({ filters: { ...clearedFilter } }),
      () => this._doFetch(),
    );
  };

  render() {
    const {
      currentPage,
      currentRecordsPerPage,
      currentTotalItems,
      currentManifestId,
      totalizers,
      progressBarState,
      isFetchingFilters,
    } = this.state;
    const { isFetching } = this.props;
    const header = document.getElementById('Header');
    const yPostion = header && header.getBoundingClientRect().y;

    return (
      <div className="ManifestsInTransit__root">
        {isFetching && (
          <div
            style={{
              position: 'fixed',
              top: yPostion > -64 ? '64px' : '0',
              zIndex: '2',
            }}
            className="Discharges__loadmask"
          >
            <LoadingIndicator text="Carregando..." />
          </div>
        )}
        <div className="ManifestsInTransit__header-container">
          <SubHeader title="Manifestos em trânsito" />
          <CurrentFilters
            filters={this.state.filters}
            onApplyFilters={this._getDataByType}
            clearAllFilters={this._clearFilters}
          />
          <SubHeaderFunctionContainer>
            <div>
              {totalizers > 0 && (
                <Totalizers
                  title="Manifestos em trânsito"
                  totalizers={totalizers}
                />
              )}
            </div>
            <SubHeaderFunctionsBar>
              <Search
                className="Tracking__header-search"
                placeholder="Busca por NF ou Manifesto"
                onSearch={query => this._onSearch(query, 1)}
              />
              <Button
                disabled={false} // "exportExcelUI.isFetching"
                skin="success"
                icon="file-excel" // exportExcelUI.isFetching ? null :
                text={null} // exportExcelUI.isFetching ? 'Gerando arquivo' :
                onClick={() => {
                  this._exportExcel();
                }}
              />
            </SubHeaderFunctionsBar>
          </SubHeaderFunctionContainer>
          <div className="ManifestsInTransit__FiltersContainer">
            <FiltersContainer
              alwaysShowPlaceholder
              isNextPageLoading={isFetchingFilters}
              isFetching={isFetchingFilters}
              defaultAmount={DEFAULT_AMOUNT}
              requestFilterOptions={filterType =>
                this._getInitialFilterOptions(filterType)
              }
              loadNextPage={this._getFilterByType}
              currentFilters={this.state.filters}
              filters={[
                {
                  identifier: 'plates',
                  label: 'PLACA',
                  type: 'paginatedSelect',
                  filterType: 'plates',
                  placeholder: 'Placa',
                  currentValue: this.state.filters.plates.value,
                  options: this.state.plates.data,
                  hasNextPage: this.state.plates.data.length !== 0,
                  totalOptions: this.state.plates.total,
                  onSearchByTerm: value =>
                    this._handleSearchByTerm(value, 'plates'),
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          plates: { ...prevState.filters.plates, value: val },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.plates.clear,
                },
                {
                  identifier: 'destination',
                  label: 'DESTINO',
                  type: 'paginatedSelect',
                  filterType: 'destination',
                  placeholder: 'Cidade Destino',
                  options: this.state.destination.data,
                  currentValue: this.state.filters.destination.value,
                  hasNextPage: this.state.destination.data.length !== 0,
                  totalOptions: this.state.destination.total,
                  onSearchByTerm: value =>
                    this._handleSearchByTerm(value, 'destination'),
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          destination: {
                            ...prevState.filters.destination,
                            value: val,
                          },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.destination.clear,
                },
                {
                  identifier: 'branches',
                  label: 'Filial',
                  type: 'paginatedSelect',
                  placeholder: 'Filial',
                  filterType: 'branches',
                  currentValue: this.state.filters.branches.value,
                  options: this.state.branches.data,
                  hasNextPage: this.state.branches.data.length !== 0,
                  totalOptions: this.state.branches.total,
                  onSearchByTerm: value =>
                    this._handleSearchByTerm(value, 'branches'),
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          branches: {
                            ...prevState.filters.branches,
                            value: val,
                          },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.plates.clear,
                },
                {
                  identifier: 'clients',
                  label: 'Cliente',
                  type: 'paginatedSelect',
                  filterType: 'clients',
                  currentValue: this.state.filters.clients.value,
                  placeholder: 'Cliente',
                  options: this.state.clients.data,
                  hasNextPage: this.state.clients.data.length !== 0,
                  totalOptions: this.state.clients.total,
                  onSearchByTerm: value =>
                    this._handleSearchByTerm(value, 'clients'),
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          clients: { ...prevState.filters.clients, value: val },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.clients.clear,
                },
                {
                  identifier: 'Status',
                  label: 'STATUS',
                  type: 'multiselect',
                  filterType: 'status',
                  placeholder: 'Status',
                  options: this.state.status.data,
                  currentValue: this.state.filters.status.value,
                  value: this.state.filters.status.value,
                  noMinWidth: true,
                  scrollAuto: true,
                  fixedOptions: true,
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          status: { ...prevState.filters.status, value: val },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.status.clear,
                },
                {
                  identifier: 'Performance',
                  label: 'PERFORMANCE',
                  type: 'multiselect',
                  filterType: 'performance',
                  placeholder: 'Performance',
                  options: this.state.performance.data,
                  currentValue: this.state.filters.performance.value,
                  value: this.state.filters.performance.value,
                  noMinWidth: true,
                  scrollAuto: true,
                  fixedOptions: true,
                  onFilter: val => {
                    this.setState(
                      prevState => ({
                        ...prevState,
                        filters: {
                          ...prevState.filters,
                          performance: {
                            ...prevState.filters.performance,
                            value: val,
                          },
                        },
                      }),
                      () => {
                        this._handlePageChange(1);
                      },
                    );
                  },
                  onClear: this.state.filters.performance.clear,
                },
              ]}
            />
          </div>
        </div>
        <div
          style={{
            marginTop: 16,
            marginRight: 16,
            marginLeft: 16,
          }}
        >
          <div>Próxima atualização em: {this._renderFormattedCounter()}</div>
          <ProgressBar
            completed={progressBarState}
            style={{
              width: 'auto',
            }}
          />
        </div>
        <Table
          onRowClick={this._onRowClick}
          className="ManifestsInTransit__table"
          headers={[
            {
              title: 'Manifesto',
              alignLeft: true,
            },
            {
              title: 'Data',
              alignLeft: true,
            },
            {
              title: 'Transportadora',
              alignLeft: true,
            },
            {
              title: 'Motorista',
              alignLeft: true,
            },
            {
              title: 'Placa',
              alignLeft: true,
            },
            {
              title: 'Início',
              alignLeft: true,
            },
            {
              title: 'Fim',
            },
            {
              title: 'Código',
              alignLeft: true,
            },
            {
              title: 'Valor',
              alignLeft: true,
            },
            {
              title: 'Doc. finalizados',
            },
            {
              title: 'Paradas',
            },
            {
              title: 'Ocorrências',
            },
            {
              title: 'Status',
            },
            {
              title: 'Performance',
            },
          ]}
          data={this._getTableData()}
        />
        {!isFetching && this._haveData() && (
          <Pagination
            options={PAGINATION_OPTIONS}
            currentPage={currentPage}
            pageLimit={currentRecordsPerPage}
            totalItems={currentTotalItems}
            onChangePage={this._handlePageChange}
            onPageLimitChange={this._handlePageLimitChange}
          />
        )}
        {currentManifestId && (
          <Details
            onDismiss={this._onDismiss}
            currentManifestId={currentManifestId}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.manifestsInTransit.isFetching,
  manifestsInTransit: state.manifestsInTransit.list,
});

const mapActionsToProps = {
  getManifestsInTransit,
};

export default connect(mapStateToProps, mapActionsToProps)(ManifestsInTransit);
